"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _materialReactTable = require("material-react-table");
var _mui_style_overrides = require("./mui_style_overrides");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const BasicTable = _ref => {
  let {
    table_data,
    table_columns,
    ...rest
  } = _ref;
  const columns = (0, _react.useMemo)(() => table_columns, []);
  const data = (0, _react.useMemo)(() => table_data, []);
  return /*#__PURE__*/_react.default.createElement(_materialReactTable.MaterialReactTable, (0, _extends2.default)({
    columns: columns,
    data: data
  }, _mui_style_overrides.styles, rest));
};
BasicTable.defaultProps = {
  enableTableFooter: false
};
BasicTable.propTypes = {
  enableTableFooter: _propTypes.default.bool
};
var _default = exports.default = BasicTable;